module.exports = {
  eventCategory: 'Editor UI | Tool Menu | customize | shapes',

  render: function () {
    this.trackEvent({
      eventAction: 'show',
      eventLabel: this.categoryKey
    });
  }
};
